import React, { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";
import "./ModalSeleccionarFiltro.css";
import { IoCheckmarkCircle, IoChevronForward, IoClose } from "react-icons/io5";

const ModalSeleccionarFiltro = ({ filtros, onSelectFiltro, filtroActual }) => {
  const { modalDispatch } = useContext(PortalContext);

  const handleSelectFiltro = (filtro) => {
    onSelectFiltro(filtro);
    hideModal()(modalDispatch);
  };

  const handleClose = () => {
    hideModal()(modalDispatch);
  };

  const isSelected = (filtro) => {
    return filtroActual?.id === filtro.id;
  };

  return (
    <div className="modal-seleccionar-filtro">
      <div className="modal-seleccionar-filtro-header">
        <h2 className="modal-seleccionar-filtro-titulo">Seleccionar filtro</h2>
        <button className="modal-seleccionar-filtro-close" onClick={handleClose}>
          <IoClose size={24} />
        </button>
      </div>
      <div className="modal-seleccionar-filtro-lista">
        {filtros.map((filtro, index) => {
          const selected = isSelected(filtro);
          
          return (
            <div
              key={index}
              className="modal-seleccionar-filtro-item"
              onClick={() => handleSelectFiltro(filtro)}
            >
              <div className="modal-seleccionar-filtro-item-left">
                <div className="modal-seleccionar-filtro-info">
                  <div className="modal-seleccionar-filtro-nombre">
                    {filtro.nombre}
                  </div>
                </div>
              </div>
              <div className="modal-seleccionar-filtro-item-right">
                {selected ? (
                  <IoCheckmarkCircle size={24} color="#0A5F8F" />
                ) : (
                  <IoChevronForward size={24} color="#999" />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModalSeleccionarFiltro;


